import React, { useEffect, useState } from 'react';
import Account from '../components/Account';
import { Box, Tab, Tabs } from '@mui/material';
import ClosetComponent from '../components/ClosetComponent';
import HomeStyles from '../styles/home.css';
import Tooltip from '@mui/material/Tooltip';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { packageApiCall } from '../utils/renderFunctions';
import OutfitBoards from '../components/OutfitBoards';

export const links = () => [{ rel: 'stylesheet', href: HomeStyles }];

const Home = () => {
  const location = useLocation();
  const [packageName, setPackageName] = useState('');
  const [value, setValue] = React.useState('1');
  const [customerData, setCustomerData] = useState({
    first_name: '',
    last_name: '',
    id: '',
    email: '',
    phone: '',
    height: '',
    weight: '',
    body_shape: '',
    preferred_style: '',
    chat_sessions_available: 0,
    video_sessions_available: 0,
    total_chat_sessions: 0,
    total_video_sessions: 0,
  });

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const handleCustomerData = async data => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/customer/${data?.id}`);
        setCustomerData(prev => ({
          ...prev,
          first_name: data.first_name ?? prev?.first_name,
          last_name: data.last_name ?? prev?.last_name,
          id: response?.data?.customer?.id ?? data?.id,
          email: response?.data?.customer?.email ?? data?.email,
          phone: response?.data?.customer?.phone ?? data?.phone,
          height: response?.data?.customer?.height ?? prev?.height,
          weight: response?.data?.customer?.weight ?? prev?.weight,
          body_shape: response?.data?.customer?.body_shape ?? prev?.body_shape,
          preferred_style: response?.data?.customer?.preferred_style ?? prev?.preferred_style,
          chat_sessions_available:
            response?.data?.customer?.chat_sessions_available ?? prev?.chat_sessions_available,
          video_sessions_available:
            response?.data?.customer?.video_sessions_available ?? prev?.video_sessions_available,
          total_chat_sessions:
            response?.data?.customer?.total_chat_sessions ?? prev?.total_chat_sessions,
          total_video_sessions:
            response?.data?.customer?.total_video_sessions ?? prev?.total_video_sessions,
        }));

        const packageResponse = await packageApiCall(response?.data?.customer?.id ?? data?.id);

        if (packageResponse?.data?.message === "You don't have plan") {
          setPackageName("You don't have plan");
        } else {
          setPackageName(packageResponse?.data?.package_name);
        }
      } catch (err) {
        console.log('error:', err);
      }
    };

    const handleUserShopifyData = () => {
      const parameters = {};
      let hash;
      const q = location.search.split('?')[1];
      if (q !== undefined) {
        const qParams = q.split('&');
        for (let i = 0; i < qParams.length; i++) {
          hash = qParams[i].split('=');
          parameters[hash[0]] = hash[1];
        }
      }

      console.log('parameters=', parameters);

      const userValues = {
        id: parameters?.id,
        email: parameters?.email,
        phone: parameters?.phone,
        height: '',
        weight: '',
        first_name: parameters?.first_name,
        last_name: parameters?.last_name,
        preferred_style: '',
        body_shape: '',
        chat_sessions_available: 0,
        video_sessions_available: 0,
        total_chat_sessions: 0,
        total_video_sessions: 0,
      };

      setCustomerData(userValues);
      handleCustomerData(userValues);
    };

    handleUserShopifyData();
  }, [location.search]);

  return (
    <div className="home-tabs-design">
      <Box>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
          <Tab label="Account" value="1" />
          {packageName === "You don't have plan" ? (
            <Tooltip title="we want YOU to be a part of this amazing community we are building! Become a member to unlock the closet feature.">
              <div>
                <Tab label="Closet" value="2" disabled />
              </div>
            </Tooltip>
          ) : (
            <Tab label="Closet" value="2" />
          )}
          <Tab label="Outfit Boards" value="3" />
        </Tabs>
        <Box>
          {value === '1' ? (
            <Account
              customerData={customerData}
              setCustomerData={setCustomerData}
              packageName={packageName}
              setPackageName={setPackageName}
            />
          ) : value === '2' ? (
            <ClosetComponent customerData={customerData} setCustomerData={setCustomerData} />
          ) : (
            <OutfitBoards customerId={customerData.id} />
          )}
        </Box>
      </Box>
    </div>
  );
};

export default Home;
